// Onboarding / Demo-Erklaermodus — Schluessel = Schweizer Hochdeutsch (kein scharfes S). Werte = FR / IT / EN.
const onboarding = {
  // ---- Willkommens-Overlay ----
  "Willkommen im KEWAGPage Kunden-Cockpit": {
    fr: "Bienvenue dans le cockpit client KEWAGPage",
    it: "Benvenuti nel cockpit clienti KEWAGPage",
    en: "Welcome to the KEWAGPage client cockpit",
  },
  "Wir zeigen Ihnen Schritt für Schritt jeden Bereich Ihres Cockpits — und genau, was Sie dort tun können. So wissen Sie von A bis Z, wo Sie was finden und erledigen.": {
    fr: "Nous vous montrons pas à pas chaque section de votre cockpit — et précisément ce que vous pouvez y faire. Ainsi, vous savez de A à Z où trouver et gérer quoi.",
    it: "Vi mostriamo passo dopo passo ogni sezione del vostro cockpit — e esattamente cosa potete farci. Così sapete dalla A alla Z dove trovare e gestire ogni cosa.",
    en: "We'll walk you through every section of your cockpit step by step — and exactly what you can do there. So you know from A to Z where to find and handle everything.",
  },
  "Rundgang starten": { fr: "Démarrer la visite", it: "Avvia il tour", en: "Start tour" },
  "Später ansehen": { fr: "Voir plus tard", it: "Guarda più tardi", en: "View later" },
  "Nicht mehr anzeigen": { fr: "Ne plus afficher", it: "Non mostrare più", en: "Don't show again" },

  // ---- Stepper ----
  "Zurück": { fr: "Retour", it: "Indietro", en: "Back" },
  "Weiter": { fr: "Suivant", it: "Avanti", en: "Next" },
  "Fertig": { fr: "Terminé", it: "Fine", en: "Done" },
  "Schritt": { fr: "Étape", it: "Passo", en: "Step" },
  "von": { fr: "sur", it: "di", en: "of" },
  "Cockpit-Rundgang": { fr: "Visite du cockpit", it: "Tour del cockpit", en: "Cockpit tour" },
  "Cockpit erklären": { fr: "Expliquer le cockpit", it: "Spiega il cockpit", en: "Explain cockpit" },

  // ---- Schritt-Titel (ergaenzend; Navigations-Labels werden zentral uebersetzt) ----
  "Website-Status": { fr: "État du site", it: "Stato del sito", en: "Website status" },
  "Aufgaben & Freigaben": { fr: "Tâches & Validations", it: "Attività & Approvazioni", en: "Tasks & Approvals" },
  "Dokumente": { fr: "Documents", it: "Documenti", en: "Documents" },
  "Benachrichtigungen": { fr: "Notifications", it: "Notifiche", en: "Notifications" },
  "Ansprechpartner": { fr: "Interlocuteur", it: "Referente", en: "Contact person" },

  // ---- Schritt-Texte (A-Z, aktionsorientiert) ----
  "Ihre Startseite. Auf einen Blick sehen Sie den Status Ihrer Website, offene Aufgaben, neue Anfragen, Supportfälle und Rechnungen. Tippen Sie auf eine Kachel, um direkt in den jeweiligen Bereich zu springen.": {
    fr: "Votre page d'accueil. En un coup d'oeil, vous voyez l'état de votre site, les tâches ouvertes, les nouvelles demandes, les cas de support et les factures. Touchez une tuile pour accéder directement à la section concernée.",
    it: "La vostra pagina iniziale. A colpo d'occhio vedete lo stato del vostro sito, le attività aperte, le nuove richieste, i casi di supporto e le fatture. Toccate una scheda per passare direttamente alla sezione corrispondente.",
    en: "Your home page. At a glance you see your website status, open tasks, new requests, support cases and invoices. Tap a tile to jump straight into the relevant section.",
  },
  "Prüfen Sie, ob Ihre Website online ist. Mit «Live prüfen» starten Sie sofort einen Check von Erreichbarkeit, SSL-Sicherheit, Backup und Ladezeit. Wird etwas rot, melden Sie sich einfach bei KEWAG.": {
    fr: "Vérifiez si votre site est en ligne. Avec « Vérifier en direct », vous lancez immédiatement un contrôle de la disponibilité, de la sécurité SSL, de la sauvegarde et du temps de chargement. Si quelque chose passe au rouge, contactez simplement KEWAG.",
    it: "Verificate se il vostro sito è online. Con «Verifica in tempo reale» avviate subito un controllo di raggiungibilità, sicurezza SSL, backup e tempo di caricamento. Se qualcosa diventa rosso, contattate semplicemente KEWAG.",
    en: "Check whether your website is online. With «Live check» you instantly run a test of availability, SSL security, backup and loading time. If something turns red, simply get in touch with KEWAG.",
  },
  "Jede Anfrage über Ihr Kontaktformular landet automatisch hier. Öffnen Sie eine Anfrage, um Name, Nachricht und Kontaktdaten zu sehen, und reagieren Sie direkt per Telefon oder E-Mail — so verpassen Sie keinen Kunden.": {
    fr: "Chaque demande via votre formulaire de contact arrive automatiquement ici. Ouvrez une demande pour voir le nom, le message et les coordonnées, et répondez directement par téléphone ou e-mail — vous ne manquez ainsi aucun client.",
    it: "Ogni richiesta tramite il vostro modulo di contatto arriva automaticamente qui. Aprite una richiesta per vedere nome, messaggio e dati di contatto e rispondete direttamente per telefono o e-mail — così non perdete nessun cliente.",
    en: "Every request via your contact form arrives here automatically. Open a request to see the name, message and contact details, and respond directly by phone or email — so you never miss a customer.",
  },
  "Hier sehen Sie, was KEWAG gerade für Sie erledigt und wo Ihre Freigabe fehlt. Prüfen Sie den Vorschlag und tippen Sie auf «Freigeben», damit wir weiterarbeiten können — oder stellen Sie eine kurze Rückfrage.": {
    fr: "Vous voyez ici ce que KEWAG réalise actuellement pour vous et où votre validation manque. Vérifiez la proposition et touchez « Valider » pour que nous puissions continuer — ou posez une brève question.",
    it: "Qui vedete cosa sta facendo KEWAG per voi e dove manca la vostra approvazione. Verificate la proposta e toccate «Approva» affinché possiamo proseguire — oppure ponete una breve domanda.",
    en: "Here you see what KEWAG is currently doing for you and where your approval is missing. Review the proposal and tap «Approve» so we can carry on — or ask a quick question.",
  },
  "Ihr direkter Draht zu KEWAG. Beschreiben Sie Ihre Frage oder Ihr Anliegen, hängen Sie bei Bedarf ein Bild an und senden Sie ab. Der KI-Assistent hilft sofort weiter oder leitet Sie an einen Menschen im Team.": {
    fr: "Votre ligne directe avec KEWAG. Décrivez votre question ou votre demande, joignez si besoin une image et envoyez. L'assistant IA vous aide immédiatement ou vous met en relation avec une personne de l'équipe.",
    it: "Il vostro filo diretto con KEWAG. Descrivete la vostra domanda o richiesta, allegate se necessario un'immagine e inviate. L'assistente IA vi aiuta subito o vi mette in contatto con una persona del team.",
    en: "Your direct line to KEWAG. Describe your question or concern, attach an image if needed and send. The AI assistant helps you right away or connects you with a person on the team.",
  },
  "Sehen Sie, wie viele Menschen Ihre Website besuchen, woher sie kommen und welche Seiten am beliebtesten sind. Ganz oben finden Sie ein monatliches Highlight in einfachen Worten.": {
    fr: "Découvrez combien de personnes visitent votre site, d'où elles viennent et quelles pages sont les plus consultées. Tout en haut, vous trouvez un point fort mensuel en mots simples.",
    it: "Scoprite quante persone visitano il vostro sito, da dove arrivano e quali pagine sono le più visitate. In alto trovate un momento clou mensile spiegato in parole semplici.",
    en: "See how many people visit your website, where they come from and which pages are most popular. At the top you'll find a monthly highlight in plain words.",
  },
  "Alle Rechnungen, Verträge, Briefings und Dateien an einem Ort. Laden Sie eine Rechnung oder ein Dokument mit einem Tippen als PDF herunter und sehen Sie Ihr Paket sowie Ihre Vertragslaufzeit.": {
    fr: "Toutes les factures, contrats, briefings et fichiers au même endroit. Téléchargez une facture ou un document en PDF d'un simple toucher et consultez votre forfait ainsi que la durée de votre contrat.",
    it: "Tutte le fatture, i contratti, i briefing e i file in un unico posto. Scaricate una fattura o un documento in PDF con un tocco e consultate il vostro pacchetto e la durata del contratto.",
    en: "All invoices, contracts, briefings and files in one place. Download an invoice or document as a PDF with a single tap, and see your package and contract term.",
  },
  "Konkrete Empfehlungen von KEWAG, wie Sie mehr aus Ihrer Website herausholen. Lesen Sie den Vorschlag und fordern Sie mit einem Klick ein unverbindliches Angebot an.": {
    fr: "Des recommandations concrètes de KEWAG pour tirer davantage de votre site. Lisez la proposition et demandez une offre sans engagement en un clic.",
    it: "Consigli concreti di KEWAG per ottenere di più dal vostro sito. Leggete la proposta e richiedete un'offerta senza impegno con un clic.",
    en: "Concrete recommendations from KEWAG on how to get more out of your website. Read the suggestion and request a no-obligation quote with one click.",
  },
  "Jeden Monat fassen wir Ihre Ergebnisse einfach verständlich zusammen: Besucher, Anfragen, erledigte Aufgaben und eine Empfehlung. Mit «Als PDF exportieren» sichern Sie den Report für Ihre Unterlagen.": {
    fr: "Chaque mois, nous résumons vos résultats de façon simple à comprendre : visiteurs, demandes, tâches réalisées et une recommandation. Avec « Exporter en PDF », vous conservez le rapport pour vos dossiers.",
    it: "Ogni mese riassumiamo i vostri risultati in modo semplice da capire: visitatori, richieste, attività completate e un consiglio. Con «Esporta come PDF» conservate il report per i vostri documenti.",
    en: "Every month we summarise your results in an easy-to-understand way: visitors, requests, completed tasks and a recommendation. With «Export as PDF» you keep the report for your records.",
  },
  "Laden Sie Mitarbeitende in Ihr Cockpit ein und legen Sie fest, welche Bereiche sie sehen dürfen. Ideal, wenn mehrere Personen in Ihrem Betrieb mitarbeiten.": {
    fr: "Invitez des collaborateurs dans votre cockpit et définissez les sections auxquelles ils ont accès. Idéal lorsque plusieurs personnes travaillent dans votre entreprise.",
    it: "Invitate collaboratori nel vostro cockpit e stabilite quali sezioni possono vedere. Ideale quando più persone lavorano nella vostra azienda.",
    en: "Invite team members into your cockpit and decide which sections they may see. Ideal when several people work in your business.",
  },
  "Ändern Sie hier Ihr Passwort und aktivieren Sie die Zwei-Faktor-Authentifizierung (2FA) für zusätzlichen Schutz. Wir empfehlen 2FA für alle Zugänge — die Einrichtung dauert weniger als eine Minute.": {
    fr: "Modifiez ici votre mot de passe et activez l'authentification à deux facteurs (2FA) pour une protection supplémentaire. Nous recommandons la 2FA pour tous les accès — la configuration prend moins d'une minute.",
    it: "Qui potete cambiare la password e attivare l'autenticazione a due fattori (2FA) per una protezione aggiuntiva. Consigliamo la 2FA per tutti gli accessi — la configurazione richiede meno di un minuto.",
    en: "Change your password here and enable two-factor authentication (2FA) for extra protection. We recommend 2FA for all accounts — setup takes less than a minute.",
  },
  "Über die Glocke oben rechts informiert Sie KEWAG über alles Neue: Aufgaben, Antworten, Dokumente, Rechnungen und Reports. Tippen Sie darauf, um alle Neuigkeiten zu sehen.": {
    fr: "Via la cloche en haut à droite, KEWAG vous informe de toutes les nouveautés : tâches, réponses, documents, factures et rapports. Touchez-la pour voir toutes les nouveautés.",
    it: "Tramite la campanella in alto a destra, KEWAG vi informa di tutte le novità: attività, risposte, documenti, fatture e report. Toccatela per vedere tutte le novità.",
    en: "Via the bell at the top right, KEWAG informs you about everything new: tasks, replies, documents, invoices and reports. Tap it to see all the latest updates.",
  },
  "Ihr persönliches KEWAG-Betreuungsteam. Mit «Nachricht senden» erreichen Sie uns jederzeit direkt aus dem Cockpit. Wir sind von A bis Z für Sie da.": {
    fr: "Votre équipe d'accompagnement KEWAG personnelle. Avec « Envoyer un message », vous nous joignez à tout moment directement depuis le cockpit. Nous sommes là pour vous de A à Z.",
    it: "Il vostro team di assistenza KEWAG personale. Con «Invia messaggio» ci raggiungete in qualsiasi momento direttamente dal cockpit. Siamo al vostro fianco dalla A alla Z.",
    en: "Your personal KEWAG care team. With «Send message» you can reach us at any time directly from the cockpit. We're here for you from A to Z.",
  },

  // ---- Geteilte Erklaer-Quelle: Labels + "Das tun Sie hier"-Aktionen (Rundgang + Seiten-Hilfe) ----
  "Das tun Sie hier": { fr: "Ce que vous faites ici", it: "Cosa fate qui", en: "What you do here" },
  "Das sehen Sie hier": { fr: "Ce que vous voyez ici", it: "Cosa vedete qui", en: "What you see here" },

  "Auf eine Kachel tippen, um direkt in den Bereich zu springen.": {
    fr: "Touchez une tuile pour accéder directement à la section.",
    it: "Toccate una scheda per passare direttamente alla sezione.",
    en: "Tap a tile to jump straight to the section.",
  },
  "Zuerst roten oder gelben Status anschauen.": {
    fr: "Regardez d'abord les statuts rouges ou jaunes.",
    it: "Guardate prima gli stati rossi o gialli.",
    en: "Look at any red or amber status first.",
  },
  "Offene Aufgaben und neue Anfragen erledigen.": {
    fr: "Traitez les tâches ouvertes et les nouvelles demandes.",
    it: "Gestite le attività aperte e le nuove richieste.",
    en: "Handle open tasks and new requests.",
  },
  "Auf «Live prüfen» tippen, um den aktuellen Status zu sehen.": {
    fr: "Touchez « Vérifier en direct » pour voir l'état actuel.",
    it: "Toccate «Verifica in tempo reale» per vedere lo stato attuale.",
    en: "Tap «Live check» to see the current status.",
  },
  "Bei Rot kurz bei KEWAG melden.": {
    fr: "En cas de rouge, contactez brièvement KEWAG.",
    it: "In caso di rosso, contattate brevemente KEWAG.",
    en: "If it's red, quickly notify KEWAG.",
  },
  "SSL, Backup und Ladezeit auf einen Blick prüfen.": {
    fr: "Vérifiez SSL, sauvegarde et temps de chargement en un coup d'oeil.",
    it: "Controllate SSL, backup e tempo di caricamento a colpo d'occhio.",
    en: "Check SSL, backup and loading time at a glance.",
  },
  "Eine Anfrage öffnen, um Nachricht und Kontaktdaten zu sehen.": {
    fr: "Ouvrez une demande pour voir le message et les coordonnées.",
    it: "Aprite una richiesta per vedere messaggio e dati di contatto.",
    en: "Open a request to see the message and contact details.",
  },
  "Direkt per Telefon oder E-Mail antworten.": {
    fr: "Répondez directement par téléphone ou e-mail.",
    it: "Rispondete direttamente per telefono o e-mail.",
    en: "Respond directly by phone or email.",
  },
  "Bearbeitete Anfragen als erledigt markieren.": {
    fr: "Marquez les demandes traitées comme terminées.",
    it: "Contrassegnate come completate le richieste gestite.",
    en: "Mark handled requests as done.",
  },
  "Vorschlag von KEWAG durchlesen.": {
    fr: "Lisez la proposition de KEWAG.",
    it: "Leggete la proposta di KEWAG.",
    en: "Read KEWAG's proposal.",
  },
  "Auf «Freigeben» tippen, wenn alles passt.": {
    fr: "Touchez « Valider » si tout convient.",
    it: "Toccate «Approva» se va tutto bene.",
    en: "Tap «Approve» if everything's fine.",
  },
  "Bei Fragen kurz zurückschreiben.": {
    fr: "En cas de question, répondez brièvement.",
    it: "In caso di domande, rispondete brevemente.",
    en: "If you have questions, reply briefly.",
  },
  "Anliegen kurz beschreiben und absenden.": {
    fr: "Décrivez brièvement votre demande et envoyez.",
    it: "Descrivete brevemente la richiesta e inviate.",
    en: "Describe your concern briefly and send.",
  },
  "Bei Bedarf ein Bild oder eine Datei anhängen.": {
    fr: "Joignez si besoin une image ou un fichier.",
    it: "Se necessario, allegate un'immagine o un file.",
    en: "Attach an image or file if needed.",
  },
  "«Mit Mensch sprechen» wählen, wenn Sie eine Person möchten.": {
    fr: "Choisissez « Parler à une personne » si vous le souhaitez.",
    it: "Scegliete «Parlare con una persona» se lo desiderate.",
    en: "Choose «Talk to a person» if you'd like one.",
  },
  "Das monatliche Highlight ganz oben lesen.": {
    fr: "Lisez le point fort mensuel tout en haut.",
    it: "Leggete il momento clou mensile in alto.",
    en: "Read the monthly highlight at the top.",
  },
  "Sehen, woher Ihre Besucher kommen.": {
    fr: "Voyez d'où viennent vos visiteurs.",
    it: "Vedete da dove arrivano i vostri visitatori.",
    en: "See where your visitors come from.",
  },
  "Beliebteste Seiten für neue Inhalte nutzen.": {
    fr: "Utilisez les pages les plus consultées pour de nouveaux contenus.",
    it: "Usate le pagine più visitate per nuovi contenuti.",
    en: "Use your most popular pages for new content.",
  },
  "Rechnung oder Dokument mit einem Tippen als PDF herunterladen.": {
    fr: "Téléchargez une facture ou un document en PDF d'un toucher.",
    it: "Scaricate una fattura o un documento in PDF con un tocco.",
    en: "Download an invoice or document as PDF with one tap.",
  },
  "Nach Rechnungen, Verträgen oder Reports filtern.": {
    fr: "Filtrez par factures, contrats ou rapports.",
    it: "Filtrate per fatture, contratti o report.",
    en: "Filter by invoices, contracts or reports.",
  },
  "Paket und Vertragslaufzeit prüfen.": {
    fr: "Vérifiez votre forfait et la durée du contrat.",
    it: "Verificate il pacchetto e la durata del contratto.",
    en: "Check your package and contract term.",
  },
  "Empfehlung von KEWAG lesen.": {
    fr: "Lisez la recommandation de KEWAG.",
    it: "Leggete il consiglio di KEWAG.",
    en: "Read KEWAG's recommendation.",
  },
  "Auf «Angebot anfordern» tippen — unverbindlich.": {
    fr: "Touchez « Demander une offre » — sans engagement.",
    it: "Toccate «Richiedi un'offerta» — senza impegno.",
    en: "Tap «Request a quote» — no obligation.",
  },
  "Offene Schritte nach und nach abhaken.": {
    fr: "Cochez les étapes ouvertes petit à petit.",
    it: "Spuntate i passi aperti man mano.",
    en: "Tick off open steps one by one.",
  },
  "Oben den gewünschten Monat auswählen.": {
    fr: "Sélectionnez le mois souhaité en haut.",
    it: "Selezionate in alto il mese desiderato.",
    en: "Select the desired month at the top.",
  },
  "Besucher, Anfragen und Empfehlung anschauen.": {
    fr: "Consultez les visiteurs, les demandes et la recommandation.",
    it: "Guardate visitatori, richieste e consiglio.",
    en: "Review visitors, requests and the recommendation.",
  },
  "Mit «Als PDF exportieren» den Report sichern.": {
    fr: "Conservez le rapport avec « Exporter en PDF ».",
    it: "Salvate il report con «Esporta come PDF».",
    en: "Save the report with «Export as PDF».",
  },
  "Auf «Benutzer einladen» tippen.": {
    fr: "Touchez « Inviter un utilisateur ».",
    it: "Toccate «Invita utente».",
    en: "Tap «Invite user».",
  },
  "Festlegen, welche Bereiche die Person sehen darf.": {
    fr: "Définissez les sections visibles pour la personne.",
    it: "Stabilite quali sezioni può vedere la persona.",
    en: "Decide which sections the person may see.",
  },
  "Zugänge jederzeit anpassen oder entfernen.": {
    fr: "Ajustez ou supprimez les accès à tout moment.",
    it: "Modificate o rimuovete gli accessi in qualsiasi momento.",
    en: "Adjust or remove access at any time.",
  },
  "Passwort bei Bedarf ändern.": {
    fr: "Modifiez votre mot de passe si nécessaire.",
    it: "Cambiate la password se necessario.",
    en: "Change your password if needed.",
  },
  "Zwei-Faktor-Authentifizierung (2FA) aktivieren.": {
    fr: "Activez l'authentification à deux facteurs (2FA).",
    it: "Attivate l'autenticazione a due fattori (2FA).",
    en: "Enable two-factor authentication (2FA).",
  },
  "Angemeldete Geräte kontrollieren.": {
    fr: "Contrôlez les appareils connectés.",
    it: "Controllate i dispositivi connessi.",
    en: "Review your logged-in devices.",
  },
  "Auf die Glocke oben rechts tippen.": {
    fr: "Touchez la cloche en haut à droite.",
    it: "Toccate la campanella in alto a destra.",
    en: "Tap the bell at the top right.",
  },
  "Neue Aufgaben, Antworten und Rechnungen sehen.": {
    fr: "Voyez les nouvelles tâches, réponses et factures.",
    it: "Vedete nuove attività, risposte e fatture.",
    en: "See new tasks, replies and invoices.",
  },
  "Direkt in die passende Ansicht springen.": {
    fr: "Accédez directement à la vue correspondante.",
    it: "Passate direttamente alla vista corrispondente.",
    en: "Jump straight to the relevant view.",
  },
  "Auf «Nachricht senden» tippen.": {
    fr: "Touchez « Envoyer un message ».",
    it: "Toccate «Invia messaggio».",
    en: "Tap «Send message».",
  },
  "Anliegen beschreiben — wir melden uns.": {
    fr: "Décrivez votre demande — nous vous répondons.",
    it: "Descrivete la richiesta — vi ricontattiamo.",
    en: "Describe your concern — we'll get back to you.",
  },

  // ---- Selbsterklaerende Leerzustaende ----
  "Neue Anfragen über Ihr Kontaktformular erscheinen hier automatisch.": {
    fr: "Les nouvelles demandes via votre formulaire de contact apparaissent ici automatiquement.",
    it: "Le nuove richieste tramite il vostro modulo di contatto appaiono qui automaticamente.",
    en: "New requests via your contact form appear here automatically.",
  },
  "Oben eine Frage stellen oder ein Problem melden — KEWAG antwortet hier.": {
    fr: "Posez une question ou signalez un problème en haut — KEWAG répond ici.",
    it: "Ponete una domanda o segnalate un problema in alto — KEWAG risponde qui.",
    en: "Ask a question or report a problem above — KEWAG replies here.",
  },
  "Sobald KEWAG Ihren ersten Report erstellt, sehen Sie ihn hier.": {
    fr: "Dès que KEWAG crée votre premier rapport, vous le voyez ici.",
    it: "Non appena KEWAG crea il vostro primo report, lo vedete qui.",
    en: "As soon as KEWAG creates your first report, you'll see it here.",
  },

  // ---- Erste-Schritte-Checkliste ----
  "Erste Schritte": { fr: "Premiers pas", it: "Primi passi", en: "Getting started" },
  "erledigt": { fr: "terminé", it: "completati", en: "done" },
  "Geschafft — jetzt loslegen": { fr: "Bravo — c'est parti", it: "Fatto — si comincia", en: "Nice — let's get started" },
  "So kommen Sie sofort ins Tun — erledigen Sie diese kurzen Schritte.": {
    fr: "Passez tout de suite à l'action — réalisez ces quelques étapes.",
    it: "Passate subito all'azione — completate questi brevi passi.",
    en: "Get started right away — complete these quick steps.",
  },
  "Cockpit-Rundgang abgeschlossen": {
    fr: "Visite du cockpit terminée", it: "Tour del cockpit completato", en: "Cockpit tour completed",
  },
  "Konto mit 2FA schützen": {
    fr: "Protéger le compte avec la 2FA", it: "Proteggere l'account con la 2FA", en: "Secure your account with 2FA",
  },
  "Ihre Website prüfen": {
    fr: "Vérifier votre site web", it: "Controllare il vostro sito web", en: "Check your website",
  },
  "Offene Freigabe erteilen": {
    fr: "Donner une validation en attente", it: "Concedere un'approvazione in sospeso", en: "Give a pending approval",
  },
  "2FA aktivieren": { fr: "Activer la 2FA", it: "Attivare la 2FA", en: "Enable 2FA" },
  "Jetzt prüfen": { fr: "Vérifier maintenant", it: "Verifica ora", en: "Check now" },
  "Zu den Freigaben": { fr: "Vers les validations", it: "Alle approvazioni", en: "To approvals" },
  "Geschafft! Sie haben alle ersten Schritte erledigt.": {
    fr: "Bravo ! Vous avez terminé toutes les premières étapes.",
    it: "Fatto! Avete completato tutti i primi passi.",
    en: "Done! You've completed all your first steps.",
  },
  "Los geht's": { fr: "C'est parti", it: "Si comincia", en: "Let's go" },
  "Später": { fr: "Plus tard", it: "Più tardi", en: "Later" },
  "Ihr grösster Hebel diesen Monat": {
    fr: "Votre plus grand levier ce mois-ci", it: "Il vostro maggior potenziale questo mese", en: "Your biggest lever this month",
  },
  "Ihre persönliche Empfehlung wird erstellt …": {
    fr: "Votre recommandation personnalisée est en cours de création …",
    it: "La vostra raccomandazione personalizzata è in preparazione …",
    en: "Preparing your personal recommendation …",
  },
  "Mit KI vertiefen": { fr: "Approfondir avec l'IA", it: "Approfondisci con l'IA", en: "Go deeper with AI" },
  "Erledigt · Nächste anzeigen": { fr: "Fait · Voir la suivante", it: "Fatto · Mostra la prossima", en: "Done · Show next" },
  "Zurücksetzen": { fr: "Réinitialiser", it: "Reimposta", en: "Reset" },

  // ---- Kontext-Hilfe pro Seite ----
  "Ihre wichtigsten Informationen auf einen Blick.": {
    fr: "Vos informations les plus importantes en un coup d'oeil.",
    it: "Le vostre informazioni più importanti a colpo d'occhio.",
    en: "Your most important information at a glance.",
  },
  "Status, Sicherheit, Backup und Performance Ihrer Website.": {
    fr: "État, sécurité, sauvegarde et performance de votre site.",
    it: "Stato, sicurezza, backup e performance del vostro sito.",
    en: "Status, security, backup and performance of your website.",
  },
  "Alle Anfragen über Ihre Website an einem Ort.": {
    fr: "Toutes les demandes via votre site au même endroit.",
    it: "Tutte le richieste tramite il vostro sito in un unico posto.",
    en: "All requests via your website in one place.",
  },
  "Alles, was Sie prüfen, freigeben oder mit KEWAG abstimmen müssen.": {
    fr: "Tout ce que vous devez vérifier, valider ou coordonner avec KEWAG.",
    it: "Tutto ciò che dovete verificare, approvare o concordare con KEWAG.",
    en: "Everything you need to review, approve or coordinate with KEWAG.",
  },
  "Fragen, Probleme und Antworten direkt mit KEWAG.": {
    fr: "Questions, problèmes et réponses directement avec KEWAG.",
    it: "Domande, problemi e risposte direttamente con KEWAG.",
    en: "Questions, problems and answers directly with KEWAG.",
  },
  "Ihre monatlichen Ergebnisse einfach erklärt.": {
    fr: "Vos résultats mensuels expliqués simplement.",
    it: "I vostri risultati mensili spiegati in modo semplice.",
    en: "Your monthly results explained simply.",
  },
  "Ihre Rechnungen, Dokumente, Paketinformationen und Laufzeit an einem Ort.": {
    fr: "Vos factures, documents, informations de forfait et durée au même endroit.",
    it: "Le vostre fatture, i documenti, le informazioni sul pacchetto e la durata in un unico posto.",
    en: "Your invoices, documents, package information and term in one place.",
  },
  "Empfehlungen und nächste Schritte für Ihren Auftritt.": {
    fr: "Recommandations et prochaines étapes pour votre présence en ligne.",
    it: "Consigli e prossimi passi per la vostra presenza online.",
    en: "Recommendations and next steps for your online presence.",
  },
  "Mitarbeiter einladen und Zugriffe steuern.": {
    fr: "Inviter des collaborateurs et gérer les accès.",
    it: "Invitare collaboratori e gestire gli accessi.",
    en: "Invite team members and manage access.",
  },
  "Passwort, 2FA und Sicherheitseinstellungen.": {
    fr: "Mot de passe, 2FA et paramètres de sécurité.",
    it: "Password, 2FA e impostazioni di sicurezza.",
    en: "Password, 2FA and security settings.",
  },

  // ---- Hilfe-Launcher / KI ----
  "Hilfe zu dieser Seite": { fr: "Aide pour cette page", it: "Aiuto per questa pagina", en: "Help for this page" },
  "Brauchen Sie noch Hilfe?": { fr: "Besoin d'aide supplémentaire ?", it: "Serve altro aiuto?", en: "Need more help?" },
  "Frage stellen": { fr: "Poser une question", it: "Fai una domanda", en: "Ask a question" },
  "Hilfe & Rundgang": { fr: "Aide & Visite", it: "Aiuto & Tour", en: "Help & Tour" },

  // ---- Rollen-Hinweis / Demo ----
  "Sie sehen dieses Cockpit als Super-Admin (Kundenansicht).": {
    fr: "Vous voyez ce cockpit en tant que super-administrateur (vue client).",
    it: "State visualizzando questo cockpit come super-amministratore (vista cliente).",
    en: "You are viewing this cockpit as a super admin (client view).",
  },
  "Demo-Modus": { fr: "Mode démo", it: "Modalità demo", en: "Demo mode" },
  "Diese Ansicht zeigt Beispieldaten und ist von echten Kundendaten getrennt.": {
    fr: "Cette vue affiche des données d'exemple et est séparée des données réelles des clients.",
    it: "Questa vista mostra dati di esempio ed è separata dai dati reali dei clienti.",
    en: "This view shows sample data and is separated from real client data.",
  },
};

export default onboarding;
